// import { stringify } from 'querystring';
import type { Reducer, Effect } from 'umi';
import { history, } from 'umi';

import { login, logout } from '@/services/login';
import { setAuthority } from '@/utils/authority';
// import { getPageQuery } from '@/utils/utils';
import { SSO_PATH } from '../../config/index'

export type StateType = {
  status?: 'ok' | 'error';
  type?: string;
  currentAuthority?: 'user' | 'guest' | 'admin';
}

export type LoginModelType = {
  namespace: string;
  state: StateType;
  effects: {
    login: Effect;
    logout: Effect;
  };
  reducers: {
    changeLoginStatus: Reducer<StateType>;
  };
}

const Model: LoginModelType = {
  namespace: 'login',
  state: {
    status: undefined,
  },

  effects: {
    *login({ payload }, { call }) {
      const response = yield call(login, payload);
      if (response.code === 0) {
        yield localStorage.setItem("sToken", response.data.sToken);

        if (response.data.loginTime) {
          history.replace('/');
        } else {
          history.push('/person?key=2');
        }

      }
    },

    *logout(_, { call, put }) {
      // const { redirect } = getPageQuery();
      const response = yield call(logout);
      if (response.code === 0) {
        // yield put({ type: "changLogin", payload: false })
        // history.replace({
        //   pathname: '/user/login',
        // });
        yield localStorage.clear();
        yield put({ type: "user/saveMenu", payload: [] });
        window.location.href = `${SSO_PATH}/user`
      }
      // Note: There may be security issues, please note
      // if (window.location.pathname !== '/user/login' && !redirect) {
      //   history.replace({
      //     pathname: '/user/login',
      //     search: stringify({
      //       redirect: window.location.href,
      //     }),
      //   });
      // }
    },
  },

  reducers: {
    changeLoginStatus(state, { payload }) {
      setAuthority(payload.currentAuthority);
      return {
        ...state,
        status: payload.status,
        type: payload.type,
      };
    },
  },
};

export default Model;
